import React, { ReactNode } from 'react';
import styled from '@emotion/styled';
import Spinner from './Spinner';

interface Props {
  text?: string;
  markup?: ReactNode;
  positionFixed?: boolean;
  fullOpacity?: boolean;
  customSpinner?: ReactNode;
  backdropProps?: React.HTMLAttributes<HTMLDivElement>;
  spinnerContainer?: React.HTMLAttributes<HTMLDivElement>;
  backgroundColor?: string;
  className?: string;
  zIndex?: number;
}

const Stretched = styled.div<{ positionFixed?: boolean; zIndex?: number }>`
  position: ${(props): string => (props.positionFixed ? 'fixed' : 'absolute')};
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: ${(props): string => (props.zIndex ? `${props.zIndex}` : '1000')};
`;

const Text = styled.div`
  margin-top: 6px;
  font-size: 13px;
  opacity: 0.5;
`;

const Overlay = (props: Props): JSX.Element => {
  const {
    text,
    positionFixed,
    markup,
    fullOpacity,
    customSpinner,
    backdropProps,
    spinnerContainer,
    backgroundColor,
    className,
    zIndex
  } = props;

  return (
    <>
      <Stretched
        positionFixed={positionFixed}
        style={{
          backgroundColor: backgroundColor || 'var(--light)',
          opacity: fullOpacity ? '1' : '0.6'
        }}
        className={'iso__overlay__backdrop'}
        {...backdropProps}
        zIndex={zIndex}
      />
      <Stretched
        style={{ flexDirection: 'column' }}
        className={`d-flex justify-content-center align-items-center iso__overlay__spinner__container ${
          className || ''
        }`}
        positionFixed={positionFixed}
        {...spinnerContainer}
        zIndex={zIndex}
      >
        {customSpinner ? <>{customSpinner}</> : <Spinner />}
        {!!text && <Text>{text}</Text>}
        {!!markup && <>{markup}</>}
      </Stretched>
    </>
  );
};
export default Overlay;
